import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { ThemeProvider, useTheme } from "@/context/ThemeContext";
import { I18nProvider } from "@/i18n";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import SalesAgent from "@/pages/SalesAgent";
import Ambassadors from "@/pages/Ambassadors";
import MediaFinder from "@/pages/MediaFinder";
import CatalogAdmin from "@/pages/CatalogAdmin";
import AgentModules from "@/pages/AgentModules";
import OrdersAdmin from "@/pages/OrdersAdmin";
import Portal from "@/pages/Portal";
import Inbox from "@/pages/Inbox";
import Contacts from "@/pages/Contacts";
import SalesStats from "@/pages/SalesStats";
import MagicLogin from "@/pages/MagicLogin";
import ResetPassword from "@/pages/ResetPassword";
import PressLounge from "@/pages/PressLounge";
import PressConfirm from "@/pages/PressConfirm";
import AmbassadorLounge from "@/pages/AmbassadorLounge";
import PressLoungeAdmin from "@/pages/PressLoungeAdmin";
import AmbassadorLoungeAdmin from "@/pages/AmbassadorLoungeAdmin";
import Settings from "@/pages/Settings";
import PrivacyNotice from "@/pages/PrivacyNotice";

function ThemedToaster() {
  const { theme } = useTheme();
  return <Toaster position="bottom-right" theme={theme} richColors />;
}

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <I18nProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/auth/magic" element={<MagicLogin />} />
            <Route path="/auth/reset" element={<ResetPassword />} />
            <Route path="/press-lounge" element={<PressLounge />} />
            <Route path="/press-confirm" element={<PressConfirm />} />
            <Route path="/privacy" element={<PrivacyNotice />} />
            <Route path="/ambassador-lounge" element={<AmbassadorLounge />} />
            <Route
              path="/"
              element={
                <ProtectedRoute>
                  <Layout><Dashboard /></Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/sales-agent"
              element={
                <ProtectedRoute role="admin">
                  <Layout><SalesAgent /></Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/ambassadors"
              element={
                <ProtectedRoute role="admin">
                  <Layout><Ambassadors /></Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/media-finder"
              element={
                <ProtectedRoute role="admin">
                  <Layout><MediaFinder /></Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/catalog-admin"
              element={
                <ProtectedRoute role="admin">
                  <Layout><CatalogAdmin /></Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/agent-modules"
              element={
                <ProtectedRoute role="admin">
                  <Layout><AgentModules /></Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/orders-admin"
              element={
                <ProtectedRoute role="admin">
                  <Layout><OrdersAdmin /></Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/sales-stats"
              element={
                <ProtectedRoute role="admin">
                  <Layout><SalesStats /></Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/press-lounge-admin"
              element={
                <ProtectedRoute role="admin">
                  <Layout><PressLoungeAdmin /></Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/ambassador-lounge-admin"
              element={
                <ProtectedRoute role="admin">
                  <Layout><AmbassadorLoungeAdmin /></Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/inbox"
              element={
                <ProtectedRoute role="admin">
                  <Layout><Inbox /></Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/contacts"
              element={
                <ProtectedRoute role="admin">
                  <Layout><Contacts /></Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/settings"
              element={
                <ProtectedRoute role="admin">
                  <Layout><Settings /></Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/portal"
              element={
                <ProtectedRoute>
                  <Layout><Portal /></Layout>
                </ProtectedRoute>
              }
            />
          </Routes>
        </BrowserRouter>
        </I18nProvider>
        <ThemedToaster />
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
